import { lazy, Suspense, useEffect, useState } from "react";

// Lightweight mount that keeps the framer-motion-powered popup out of the
// critical bundle. We only listen for the trigger event / storage signal;
// the actual popup component is fetched on-demand when it fires.
const B2BCommissionPopup = lazy(() =>
  import("./B2BCommissionPopup").then((m) => ({ default: m.B2BCommissionPopup })),
);

const STORAGE_KEY = "otv_b2b_commission_popup_signal";

export function B2BCommissionPopupMount() {
  const [shouldMount, setShouldMount] = useState(false);

  useEffect(() => {
    if (shouldMount) return;
    const onEvent = () => setShouldMount(true);
    window.addEventListener("otv:b2b-commission-popup", onEvent);
    try {
      const sig = sessionStorage.getItem(STORAGE_KEY);
      if (sig && Date.now() - Number(sig) < 5000) setShouldMount(true);
    } catch {}
    return () => window.removeEventListener("otv:b2b-commission-popup", onEvent);
  }, [shouldMount]);

  if (!shouldMount) return null;
  return (
    <Suspense fallback={null}>
      <B2BCommissionPopup />
    </Suspense>
  );
}
